import { H1 } from "@dune/ui";
import { useEffect } from "react";
import { useCreateOrGetConstructionSiteSubmission } from "../../../api/mutations/constructionSiteSubmission.mutations";
import { GoBackButton } from "../../../component/common/GoBackButton";
import { Page } from "../../../component/common/Page";
import { FileWithMetadataPreviewWrapper } from "../../../component/layout/FileWithMetadataPreviewWrapper";
import { useRequiredParams } from "../../../hooks/useRequiredParams";
import { getConstructionSiteTitle } from "../ConstructionSitePage";
import { ProjectSubmissionContent } from "./ProjectSubmissionContent";

export const ProjectSubmission = () => {
	const { constructionSiteId } = useRequiredParams<{
		constructionSiteId: string;
	}>();

	const { mutate: createOrGetSubmission } =
		useCreateOrGetConstructionSiteSubmission();

	useEffect(() => {
		if (constructionSiteId) {
			createOrGetSubmission(Number(constructionSiteId));
		}
	}, [constructionSiteId, createOrGetSubmission]);

	return (
		<Page>
			<FileWithMetadataPreviewWrapper>
				<div>
					<GoBackButton />
					<H1>
						Soumission {getConstructionSiteTitle(Number(constructionSiteId))}
					</H1>
				</div>
				<ProjectSubmissionContent />
			</FileWithMetadataPreviewWrapper>
		</Page>
	);
};
